// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1VK3a","col":"styles_col__28eqD"};